import pkdApi from 'store/api/pkd';
import { PROJECT } from 'constants';

const arrayToMap1UpStatus = (array) => {
  array = Array.isArray(array) ? array : Object.values(array);
  return array?.reduce?.((obj, { healthSystemId, ...attributes }, index) => {
    healthSystemId = healthSystemId ?? `unknown_${index}`;
    return Object.assign(obj, { [healthSystemId]: attributes });
  }, {});
};

const oneUpApi = pkdApi.injectEndpoints({
  endpoints : (build) => ({
    create1UpUser : build.mutation({
      query : ({ participantId, healthSystemId, name }) => ({
        url    : '/oneup/create',
        method : 'POST',
        body   : {
          project      : PROJECT,
          participantId,
          healthSystemId,
          providerName : name,
        },
      }),
      invalidatesTags : ['1UpStatus'],
    }),
    initiate1UpDataFetch : build.mutation({
      query : ({ participantId }) => ({
        url    : '/oneup/initiate-data-fetch',
        method : 'POST',
        body   : { project: PROJECT, participantId },
      }),
      invalidatesTags : ['1UpStatus'],
    }),
    fetch1UpProvidersList : build.query({
      query : ({ id }) => ({
        url    : `/oneup/providers-list?id=${id}`,
        method : 'GET',
      }),
      providesTags : ['1UpProviderList'],
    }),
    resource1UpDataFetchStatus : build.query({
      query : ({ participantId }) => ({
        url    : '/oneup/resource-data-fetch-status',
        method : 'GET',
        params : { project: PROJECT, participantId },
      }),
      transformResponse : arrayToMap1UpStatus,
      providesTags      : ['1UpStatus'],
    }),
  }),
  overrideExisting : false,
});

export const {
  useCreate1UpUserMutation,
  useInitiate1UpDataFetchMutation,
  useFetch1UpProvidersListQuery,
  useResource1UpDataFetchStatusQuery,
} = oneUpApi;
